<template>
    <div class="medical-column-detail-list" v-if="channelList && channelList.length">
        <van-list v-if="channelList" v-model="loading" :finished="finished" finished-text="已到底部" @load="onLoad">
            <div v-for="(item, index) in channelList" :key="item.id">
                <Lives :dataItem="item.content" :otherDataItem="item" />
                <van-divider v-if="index !== channelList.length - 1" />
            </div>
        </van-list>
    </div>
</template>

<script>
import Lives from './lives.vue'
import Interface from '@/util/interface.js'
export default {
    components: {
        Lives
    },
    data() {
        return {
            finished: false,
            isLoading: true,
            channelList: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0
        }
    },
    methods: {
        onLoad() {
            this.finished = false
            this.loading = true
            this.page.page++
            this.fetch('channelList')
        },
        onRefresh() {
            this.isLoading = true
            this.page = { page: 1, pageSize: 5 }
            this.fetch('channelList')
        },
        fetch(scene) {
            if (scene === 'channelList') {
                const params = {
                    page:this.page.page,
                    pageSize:this.page.pageSize,
                    course_id: this.$route.params.id
                }
                Interface.getData('get', '/course/api/course/recommend', params).then(res => {
                    console.log(res)
                    this.channelList = [...this.channelList, ...res.data.list]
                    this.total = res.data.total
                    this.loading = false
                    this.isLoading = false

                    if (this.channelList.length >= this.total) {
                        this.finished = true
                    }
                })
            }
        }
    },
    created() {
        this.fetch('channelList')
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/course/components/recommend.vue